import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [

    {
      name: "MaintenanceMode",
      path: "/maintenance_mode",
      component: () => import("@/views/main/MaintenanceMode"),
      meta: {
        permission: 'guest'
      }
    },
    {
      path: "/Guidelines",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: '/',
          component: () => import("@/views/main/guidelines/Guidelines"),
        }
      ],
      meta: {
        permission: 'user-auth'
      }
    },
    {
      name: "LandingPage",
      path: "/:token?",
      component: () => import("@/views/main/LandingPage"),
      meta: {
        permission: 'guest'
      },
    },
    {
      name: "CompleteSignUp",
      path: "/complete/sign_up",
      component: () => import("@/views/main/signup/SignUp"),
      meta: {
        permission: 'user-auth'
      }
    },
    {
      name: "PendingAccount",
      path: "/account/pending",
      component: () => import("@/views/authentication/Pending"),
      meta: {
        permission: 'user-auth'
      }
    },
    {
      name: "DeactivatedAccount",
      path: "/account/deactivated",
      component: () => import("@/views/authentication/Deactivated"),
      meta: {
        permission: 'user-auth'
      }

    },
    {
      name: "DisapprovedAccount",
      path: "/account/disapproved",
      component: () => import("@/views/authentication/Disapproved"),
      meta: {
        permission: 'user-auth'
      }
    },

    {
      path: '/client',
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: 'NoDomainAssigned',
          path: "survey/form/no-domain-assigned",
          component: () => import("@/views/main/others/NoAssignedDomain"),
        },
        {
          path: "survey/form",
          redirect: '/client/survey/form/1',
          component: () => import("@/views/main/Questionnaire"),
          children: [
            {
              path: "1",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.1"),
            },
            {
              path: "2",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.2"),
            },
            {
              path: "3",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.3"),
            },
            {
              path: "4",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.4"),
            },
            {
              path: "5",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.5"),
            },
            {
              path: "6",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.6"),
            },
            {
              path: "7",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.7"),
            },
            {
              path: "8",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.8"),
            },
            {
              path: "9",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.9"),
            },
            {
              path: "10",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.10"),
            },
            {
              path: "11",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.11"),
            },
            {
              path: "12",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.12"),
            },
            {
              path: "13",
              component: () => import("@/views/main/sub-components/leadership-and-governance/1.13"),
            },
          ]
        },
        {
          path: "survey/form/section_2",
          component: () => import("@/views/main/Questionnaire"),
          children: [
            {
              path: "2_1_1",
              component: () => import("@/views/main/sub-components/infrastructures/2.1.1"),
            },
            {
              path: "2_1_2",
              component: () => import("@/views/main/sub-components/infrastructures/2.1.2"),
            },
            {
              path: "2_1_3",
              component: () => import("@/views/main/sub-components/infrastructures/2.1.3"),
            },
            {
              path: "2_2_1",
              component: () => import("@/views/main/sub-components/infrastructures/2.2.1"),
            },
            {
              path: "2_2_2",
              component: () => import("@/views/main/sub-components/infrastructures/2.2.2"),
            },
            {
              path: "2_2_3",
              component: () => import("@/views/main/sub-components/infrastructures/2.2.3"),
            },
            {
              path: "2_2_4",
              component: () => import("@/views/main/sub-components/infrastructures/2.2.4"),
            },
            {
              path: "2_3_1",
              component: () => import("@/views/main/sub-components/infrastructures/2.3.1"),
            },
            {
              path: "2_3_2",
              component: () => import("@/views/main/sub-components/infrastructures/2.3.2"),
            },
            {
              path: "2_3_3",
              component: () => import("@/views/main/sub-components/infrastructures/2.3.3"),
            },
            {
              path: "2_3_4",
              component: () => import("@/views/main/sub-components/infrastructures/2.3.4"),
            },
            {
              path: "2_3_5",
              component: () => import("@/views/main/sub-components/infrastructures/2.3.5"),
            },
            {
              path: "2_3_6",
              component: () => import("@/views/main/sub-components/infrastructures/2.3.6"),
            },
            {
              path: "2_3_7",
              component: () => import("@/views/main/sub-components/infrastructures/2.3.7"),
            },
            {
              path: "2_3_8",
              component: () => import("@/views/main/sub-components/infrastructures/2.3.8"),
            },
          ]
        },
        {
          path: "survey/form/section_3",
          component: () => import("@/views/main/Questionnaire"),
          children: [
            {
              path: "1",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.1"),
            },
            {
              path: "2",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.2"),
            },
            {
              path: "3",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.3"),
            },
            {
              path: "4",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.4"),
            },
            {
              path: "5",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.5"),
            },
            {
              path: "6",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.6"),
            },
            {
              path: "7",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.7"),
            },
            {
              path: "8",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.8"),
            },
            {
              path: "9",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.9"),
            },
            {
              path: "10",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.10"),
            },
            {
              path: "11",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.11"),
            },
            {
              path: "12",
              component: () => import("@/views/main/sub-components/teaching-and-learning/3.12"),
            },
          ]
        },
        {
          path: "survey/form/section_4",
          component: () => import("@/views/main/Questionnaire"),
          children: [
            {
              path: "1",
              component: () => import("@/views/main/sub-components/research-commons/4.1"),
            },
            {
              path: "2",
              component: () => import("@/views/main/sub-components/research-commons/4.2"),
            },
            {
              path: "3",
              component: () => import("@/views/main/sub-components/research-commons/4.3"),
            },
            {
              path: "4",
              component: () => import("@/views/main/sub-components/research-commons/4.4"),
            },
            {
              path: "5",
              component: () => import("@/views/main/sub-components/research-commons/4.5"),
            },
            {
              path: "6",
              component: () => import("@/views/main/sub-components/research-commons/4.6"),
            },
            {
              path: "7",
              component: () => import("@/views/main/sub-components/research-commons/4.7"),
            },
            {
              path: "8",
              component: () => import("@/views/main/sub-components/research-commons/4.8"),
            },
            {
              path: "9",
              component: () => import("@/views/main/sub-components/research-commons/4.9"),
            },
          ]
        },
        {
          path: "survey/form/section_5",
          component: () => import("@/views/main/Questionnaire"),
          children: [
            {
              path: "1",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.1"),
            },
            {
              path: "2",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.2"),
            },
            {
              path: "3",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.3"),
            },
            {
              path: "4",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.4"),
            },
            {
              path: "5",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.5"),
            },
            {
              path: "6",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.6"),
            },
            {
              path: "7",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.7"),
            },
            {
              path: "8",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.8"),
            },
            {
              path: "9",
              component: () => import("@/views/main/sub-components/institutional-support-systems/5.9"),
            },
          ]
        },
        {
          path: "survey/form/section_6",
          component: () => import("@/views/main/Questionnaire"),
          children: [
            {
              path: "1",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.1"),
            },
            {
              path: "2",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.2"),
            },
            {
              path: "3",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.3"),
            },
            {
              path: "4",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.4"),
            },
            {
              path: "5",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.5"),
            },
            {
              path: "6",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.6"),
            },
            {
              path: "7",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.7"),
            },
            {
              path: "8",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.8"),
            },
            {
              path: "9",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.9"),
            },
            {
              path: "10",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.10"),
            },
            {
              path: "11",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.11"),
            },
            {
              path: "12",
              component: () => import("@/views/main/sub-components/sustainability-and-resiliency-of-operations/6.12"),
            },
          ]
        },
        {
          path: "survey/form/section_7",
          component: () => import("@/views/main/Questionnaire"),
          children: [
            {
              path: "1",
              component: () => import("@/views/main/sub-components/others/7.1"),
            },
            {
              path: "2",
              component: () => import("@/views/main/sub-components/others/7.2"),
            },
            {
              path: "3",
              component: () => import("@/views/main/sub-components/others/7.3"),
            },
            {
              path: "4",
              component: () => import("@/views/main/sub-components/others/7.4"),
            },
          ]
        },
      ],
      meta: {
        permission: 'user-auth'
      }
    },

    {
      path: "/temp/form",
      redirect: '/client/survey/form/1',
    },

    {
      path: "/institution/profile",
      component: () => import("@/views/main/InstitutionProfile"),
      meta: {
        permission: 'user-auth'
      }
    },
    

    {
      path: "/admin",
      redirect: "dashboard",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "Dashboard",
          path: "dashboard",
          component: () => import("@/views/main/dashboard/Dashboard"),
        },
        {
          name: "Accounts",
          path: "user/accounts",
          component: () => import("@/views/main/accounts/Accounts"),
        },
        {
          name: "InstitutionProfile",
          path: "institution/profile",
          component: () => import("@/views/main/InstitutionProfile"),
        },
      ],
      meta: {
        permission: 'user-auth'
      }
    },
    {
      path: "*",
      // redirect: '/maintenance_mode',
      component: () => import("@/views/authentication/Error"),
    },
  ],
});



router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.permission === "guest")){
    if(to.path === '/maintenance_mode'){
      next('/');
    }
    else{
      next();
    }
  }


  // if(to.matched.some(record => record.meta.permission === "user-auth") && !authenticated){
  if(to.matched.some(record => record.meta.permission === "user-auth")){
    next()
    // next('/')
  }

  else{
    next();
  }

  // if(to.path == '/admin/dashboard'){
  //   next('/admin/user/accounts')
  // }
  // else{
  //   next();
  // }
});


import NProgress from "nprogress";
import Store from "@/store/store.js";

let store;
let user;
let account_status = '';
let authenticated = false;
let roles = [];
let institution = null;


store = Store;
user = store.getters.GET_USER;
account_status = user && user.account_status ? user.account_status.status.toLowerCase() : null;
authenticated = store.getters.IS_AUTHENTICATED ? store.getters.IS_AUTHENTICATED : false;
roles = user.user_roles;
institution = user.institution_id;


router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }

  next();

  // if(store.getters.IS_AUTHENTICATED){

  //   if(to.path === '/'){
  //     if(account_status == 'pending'){
  //       if(to.path !== '/complete/sign_up'){
  //         next('/account/pending');
  //       }
  //       else{
  //         next();
  //       }
  //     } 
  //     else if(account_status === 'disapproved'){
  //       next('/account/disapproved');
  //     } 
  //     else if(account_status === 'deactivated'){
  //       next('/account/deactivated');
  //     }
  //     else if(account_status === 'active'){
  //       if(roles.includes('CHED RO ADMIN') || roles.includes('SUC ADMIN') || roles.includes('SUPER ADMIN')){
  //         next('/admin/dashboard');
  //       }
  //       else{
  //         next('/temp/form');
  //       }
  //     }
  //     else{
  //       next();
  //     }
  //   }

  //   else{
  //     if(account_status == 'pending' || account_status === 'disapproved' || account_status === 'deactivated'){
  //       if(account_status == 'pending' && to.path != '/account/pending'){
  //         if((institution || roles.length > 0) && to.path == '/complete/sign_up'){
  //           next('/account/pending');
  //         }
  //         else{
  //           next();
  //         }
  //       }
  //       else {
  //         if(!institution || roles.length == 0){
  //           next('/complete/sign_up');
  //         }
  //         else{
  //           next();
  //         }
  //       }

  //       if(account_status == 'disapproved' && to.path != '/account/disapproved'){
  //         next('/account/disapproved');
  //       }
  //       else{
  //         next();
  //       }

  //       if(account_status == 'deactivated' && to.path != '/account/deactivated'){
  //         next('/account/deactivated');
  //       }
  //       else{
  //         next();
  //       }
  //     }
  //     else{
  //       if(!(roles.includes('CHED RO ADMIN') || roles.includes('SUC ADMIN') || roles.includes('SUPER ADMIN'))){
  //         if(to.path.includes('/admin')){
  //           next('/');
  //         }
  
  //         else{
  //           next();
  //         }
  //       }
  //       else{
  //         next();
  //       }

  //     }
  //   }  
  // }
  // else{
  //   next();
  // }
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
